import api from '../'

const getDefaultProfilesList = () => {
  return api.get(`/administration/general/default_lms_profiles`).then(({ data }) => {
    return data
  })
}

export default getDefaultProfilesList
